import { Loader2Icon } from "lucide-react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const spinnerVariants = cva(
  "animate-spin",
  {
    variants: {
      size: {
        default: "size-4",
        sm: "size-2",
        lg: "size-6",
        icon: "size-10",
      },
      variant: {
        default: "text-foreground",
        primary: "text-primary",
        secondary: "text-semantic-border",
        inherit: "text-current",
      },
    },
    defaultVariants: {
      size: "default",
      variant: "default",
    },
  }
)

export interface SpinnerProps
  extends React.ComponentProps<"svg">,
  VariantProps<typeof spinnerVariants> { }

function Spinner({ className, size, variant, ...props }: SpinnerProps) {
  return (
    <Loader2Icon
      role="status"
      aria-label="Loading"
      className={cn(spinnerVariants({ size, variant, className }))}
      {...props}
    />
  )
}

export { Spinner, spinnerVariants }
